import React from 'react';

import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';

import { colors } from 'theme/palette';

import Button from 'components/Button';
import Typography from 'components/Typography';

import { ReactComponent as MathIcon } from './assets/math.svg';
import { ReactComponent as NonMathIcon } from './assets/non-math.svg';
import styles from './styles.module.scss';

const SubjectSelect = ({ selectSubject }) => {
  return (
    <section className={styles.container}>
      <main className={styles.cardsGrid}>
        <div className={styles.card}>
          <Typography
            variant="H-TEXT-2"
            color={colors.pink1}
            className={styles.cardTitle}
          >
            Math assignment
          </Typography>
          <div className={styles.iconWrapper}>
            <MathIcon />
          </div>
          <Button
            className={styles.getStartedButton}
            color="#BDC0FF"
            endIcon={<ArrowRightAltIcon />}
            onClick={() => selectSubject('math')}
          >
            Get started
          </Button>
        </div>

        <div className={styles.card}>
          <Typography
            variant="H-TEXT-2"
            color={colors.pink1}
            className={styles.cardTitle}
          >
            Non-math assignment
          </Typography>
          <div className={styles.iconWrapper}>
            <NonMathIcon />
          </div>
          <Button
            className={styles.getStartedButton}
            color="#BDC0FF"
            endIcon={<ArrowRightAltIcon />}
            onClick={() => selectSubject('npn-math')}
          >
            Get started
          </Button>
        </div>
      </main>
    </section>
  );
};

export default SubjectSelect;
